import { useEffect, useState } from "react";

/**
 * useDemoSubmission — small hook that reads the persisted Toolbox Talk
 * (or other demo) submission from localStorage. Returns null when the
 * record is missing or has expired (>30 minutes old).
 *
 * Used by record-list pages (MeetingsDashboard, etc.) to highlight the
 * exact row the visitor just submitted from /demo and stamp it with
 * a "YOUR DEMO SUBMISSION" badge — closing the persistence loop.
 */
const STORAGE_KEY = "forgeops.demo.lastSubmission";
const TTL_MS = 30 * 60 * 1000;

export function useDemoSubmission() {
  const [sub, setSub] = useState(null);

  useEffect(() => {
    const read = () => {
      try {
        const raw = window.localStorage.getItem(STORAGE_KEY);
        if (!raw) return setSub(null);
        const parsed = JSON.parse(raw);
        if (!parsed || !parsed.kind) return setSub(null);
        const ageMs = Date.now() - new Date(parsed.at).getTime();
        if (Number.isFinite(ageMs) && ageMs > TTL_MS) return setSub(null);
        setSub(parsed);
      } catch {
        setSub(null);
      }
    };
    read();
    const onStorage = (e) => {
      if (!e || e.key === STORAGE_KEY) read();
    };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, []);

  return sub;
}

export default useDemoSubmission;
